<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">角色修改</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body" style="height: 300px;">

                <el-form :model="addForm" :rules="rules" ref="addForm" label-width="80px">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="addForm.name" v-if="addForm.name != '机构管理员' " ></el-input>
                                    <el-input v-model="addForm.name" v-if="addForm.name == '机构管理员' " disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" required prop="sort">
                                    <el-input v-model="addForm.sort"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="菜单" required>
                                    <el-tree
                                            :data="listMenuDTO"
                                            show-checkbox
                                            default-expand-all
                                            node-key="menuCode"
                                            ref="tree"
                                            highlight-current
                                            :props="defaultProps">
                                    </el-tree>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        data() {
            return {
                loading: false,

                listMenuDTO:[],
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    sort:'',
                    roleCode:'',
                    listMenu:[],

                },

                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                    ],

                }

            }
        },

        methods: {

            init(row){

                this.addForm.name = row.name.substring(1,row.name.length-1);
                this.addForm.sort = row.sort;
                this.addForm.roleCode = row.roleCode;

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Menu/GovList",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response) => {
                        //console.log(JSON.stringify(response.data));
                        if (response.data.error == 0) {
                            //this.listMenuDTO = response.data.data;

                          let arr = response.data.data;
                          let ss = JSON.stringify(arr);
                          let arr2 = this.deleteSome(ss);
                          let aa =  JSON.stringify(arr2);
                          aa = aa.replaceAll("Gov","");
                          this.listMenuDTO = JSON.parse(aa);

                          this.checkedNode(row.listMenu);

                        }
                    })

            },

          deleteSome(ss){

            let arr =  JSON.parse(ss);

            let arr0 = arr[0].listMenuDTO;
            for(let i=0;i< arr0.length;i++){
              let arr2 = arr0[i];
              if(arr2.name == '分配账号管理'){
                arr0.splice(i,1);
              }
            }

            //console.log(arr);

            return arr;

          },



          isLast(arr,menuCode){
              for(var i=0;i<arr.length;i++){
                  var item = arr[i];
                  if(item.parentMenuCode == menuCode){
                      return false;
                  }
              }
              return true;
          },

          checkedNode(listMenu){
              var getArr = [];
              var arr = listMenu;
              for(var i=0;i<arr.length;i++){
                  if(this.isLast(listMenu,arr[i].menuCode)){
                      getArr.push(arr[i].menuCode);
                  }
              }
              this.$nextTick(function(){
                  this.$refs.tree.setCheckedKeys(getArr);
              })
              console.log(getArr)
          },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){

                        let array1 = []; //一级数组
                        let array2 = []; //二级数组

                        let nodes = this.$refs.tree.getCheckedNodes(false,true);
                        console.log(nodes);
                        //分开1级菜单
                        for(let i = 0; i<nodes.length;i++){
                            let list1 = {
                                menuCode:nodes[i].menuCode,
                                parentMenuCode:nodes[i].parentMenuCode,
                                name:nodes[i].name,
                                listMenu:[]
                            };
                            if(nodes[i].parentMenuCode == "00000000-0000-0000-0000-000000000000"){
                                array1.push(list1);
                            }else {
                                array2.push(list1);
                            }
                        }
                        console.log(array1);
                        console.log(array2);
                        //分开2级菜单，
                        for(let k in array1){
                            for(let j in array2){
                                let list2 = {
                                    menuCode:array2[j].menuCode,
                                    parentMenuCode:array2[j].parentMenuCode,
                                    name:array2[j].name,
                                    listMenu:[]
                                };
                                if(array2[j].parentMenuCode == array1[k].menuCode){
                                    array1[k].listMenu.push(list2);
                                }

                            }
                        }
                        console.log(array1);
                        for(let n in array1){
                            for(let m in array1[n].listMenu){
                                for (let l in array2){
                                    let list3 = {
                                        menuCode:array2[l].menuCode,
                                        parentMenuCode:array2[l].parentMenuCode,
                                        name:array2[l].name,
                                        listMenu:[]
                                    };
                                    if(array1[n].listMenu[m].menuCode == array2[l].parentMenuCode){
                                        array1[n].listMenu[m].listMenu.push(list3);
                                    }
                                }
                            }
                        }

                        console.log("数组1："+JSON.stringify(array1));
                        this.addForm.listMenu = array1;

                        if(this.addForm.listMenu ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }

                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

              this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

              this.addForm.name = "["+this.addForm.name+"]";

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Role/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )
            },

        }
    }


</script>



<style lang="scss" scoped>

</style>
